import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { getUserRole } from '../../constants/tenancy';

// Renders its page only for the listed roles; anyone else lands on the
// dashboard. The API enforces the same rule — this just avoids a page of 403s.
const RequireRole = ({ roles, children }) => (roles.includes(getUserRole()) ? children : <Navigate to="/dashboard" replace />);

RequireRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node,
};

export default RequireRole;
